import React from 'react';

import OpsLeaderCard from './OpsLeaderCard';
import { HierarchyUser, ProcurementExecutive } from '../../codegen/graphql';
import ProcurementExecutives from './ProcurementExecutives';

type Props = {
    director: HierarchyUser;
    executives: ProcurementExecutive[];
};

function ProcurementTeam({ director, executives }: Props) {
    return (
        <>
            <OpsLeaderCard personsRole="director" person={director} />
            <div className="mt-8 relative z-0">
                <ProcurementExecutives executives={executives} />
            </div>
        </>
    );
}

export default ProcurementTeam;
